export default __webpack_public_path__ + "fonts/KFOlCnqEu92Fr1MmEU9fCBc4EsA.woff2";